export default __webpack_public_path__ + "static/bg-schroders-680ab6aeb8766ede5426124f95b71dc9.webp";